import React, { Suspense, lazy, useState } from 'react'
import { useRoutes } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import LoaderScreen from './components/common/Loader'
import Toaster from './components/common/Toaster.js'
import { updateShowAlert, updateUserDetails } from './redux/Actions.js'
//import { mainMenuList } from './components/common/menuConstant.js'
import { useEffect } from 'react'
import ContactUS from './components/ContactUs/index.jsx'
import './styles/common.scss'
import TripScheduleFromURL from './components/Booking/TripDetailed/TripSchedule/tripScheduleFromURL.jsx'
import { useMainMenuList } from './components/common/menuConstant.js'
import './polyfills/nativeBridge.js'

const Login = lazy(() => import('./components/Login'))
const Logout = lazy(() => import('./components/Login/logout'))
const ManageDevice = lazy(() => import('./components/ManageDevice'))
const PickupInquaryReportURL = lazy(() => import('./components/Booking/TripDetailed/PickupwiseInquiry/pickupWiseInquaryFromURL'));

const App = () => {
  const mainMenuList = useMainMenuList();
  const { common } = useSelector((store) => store)
  const dispatch = useDispatch()
  const { showAlert, userDetails } = common
  const [isLogin, setIsLogin] = useState(null)
  const checkSession = () => {
    const isLogin = sessionStorage.getItem('BusCrsCheckSum')
    setIsLogin(!!isLogin)
    if (isLogin && window.location.pathname.startsWith('/X=')) {
      window.location.replace('/')
    }
  }
  useEffect(() => {
    let user = sessionStorage.getItem("userDetails");
    let roleData = sessionStorage.getItem("roleDetails");
    if (user && Object.keys(userDetails)?.length === 0) {
      dispatch(updateUserDetails(JSON.parse(user), JSON.parse(roleData)));
    }
    setTimeout(() => {
      checkSession();
    }, 50);
  }, []);

  const routes = [
    { path: '/contact_us', element: <ContactUS /> },
    {
      path: '/delete_account',
      element: (
        <ManageDevice header="Delete Account" btnName="Delete" showDevice={false} />
      ),
    },
    { path: '/pickup_inquiry', element: <PickupInquaryReportURL /> },
    { path: '/trip_schedule', element: <TripScheduleFromURL /> },
    { path: '/logout', element: <Logout setIsLogin={setIsLogin} /> },
    ...(isLogin||(window.location.pathname==='/branchRecharge'&&window.location.search.includes('b='))
      ? mainMenuList.flatMap((val) => val.subMenu)
      : [
        { path: '/manageDevice', element: <ManageDevice /> },
        { path: '/', element: <Login setIsLogin={setIsLogin} /> },
        { path: '*', element: <Login setIsLogin={setIsLogin} /> },
      ]),
  ];
  const AllRoutes = useRoutes(routes)
  return (
    <>
      <Suspense fallback={<LoaderScreen />}>
        {common.loadingScreen && <LoaderScreen />}
        {AllRoutes}
      </Suspense>
      <Toaster
        open={showAlert?.open}
        message={showAlert?.msg}
        type={showAlert?.type}
        autoHideDuration={showAlert?.autoHideDuration}
        horizontalPosition={showAlert?.horizontalPosition}
        onClose={() => {
          dispatch(
            updateShowAlert({
              msg: '',
              open: false,
              type: '',
              autoHideDuration: 5000,
              horizontalPosition: 'center',
            })
          )
        }}
      />
    </>
  )
}

export default App